<template>
  <div>
    <NavBar :admin="true" :items="items" />
		<v-main>
			<v-container>
        <v-progress-linear indeterminate color="primary" v-if="loading"></v-progress-linear>
        <template v-else>
          <DrugForm :drug="drug" />
        </template>
			</v-container>
		</v-main>
  </div>
</template>

<script>
import NavBar from "@/components/authentication/NavBar.vue";
import DrugForm from "@/components/drugs/DrugForm.vue";

export default {
  name: "EditDrug",
  components: {
    NavBar,
    DrugForm
  },
  data: () => ({
    loading: false,
    drug: {
      name: "",
      generic_name: "",
      farm_formula: "",
      dosage: "",
      is_generic: false,
      owner: "",
      farm_groups: [],
      extra_info: {
        pt: {
          indications: "",
          contraindications: "",
          secundary_effects: ""
        },
        en: {
          indications: "",
          contraindications: "",
          secundary_effects: ""
        },
        es: {
          indications: "",
          contraindications: "",
          secundary_effects: ""
        }
      }
    }
  }),
  computed: {
		items() {
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: "/admin/dashboard"
				},
				{
					text: this.$gettext("Drugs"),
					disabled: false,
          link: true,
          to: "/admin/dashboard/drugs"
        },
        {
					text: this.$gettext("New"),
					disabled: true,
					link: true
				}
			];
		}
  }
}
</script>